// // // import React, { useState } from "react";
// // // import { 
// // //   Box, Autocomplete, TextField, Button, Chip, 
// // //   useMediaQuery, useTheme, Modal, IconButton, Typography 
// // // } from "@mui/material";
// // // import CloseIcon from '@mui/icons-material/Close';



// // // const DepartmentSelector = ({
// // //   departments,
// // //   selectedDepartments,
// // //   onAddDepartments,
// // //   setSelectedDepartments,
// // //   isEdit
// // // }) => {
// // //   const theme = useTheme();
// // //   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
// // //   const [mobileModalOpen, setMobileModalOpen] = useState(false);

// // //   const safeOptions = (departments || [])
// // //   .filter(d => d && d.name)
// // //   .map(d => d.name);

// // //   // Mobile-specific Autocomplete in modal
// // //   const MobileDepartmentModal = () => (
// // //     <Modal
// // //       open={mobileModalOpen}
// // //       onClose={() => setMobileModalOpen(false)}
// // //       sx={{
// // //         display: 'flex',
// // //         alignItems: 'flex-start',
// // //         justifyContent: 'center',
// // //         p: 2,
// // //         mt: isMobile ? 10 : 4
// // //       }}
// // //     >
// // //       <Box sx={{
// // //         bgcolor: 'background.paper',
// // //         borderRadius: 2,
// // //         boxShadow: 24,
// // //         width: '100%',
// // //         maxWidth: 500,
// // //         maxHeight: '80vh',
// // //         overflow: 'hidden',
// // //         display: 'flex',
// // //         flexDirection: 'column'
// // //       }}>
// // //         {/* Modal Header */}
// // //         <Box sx={{
// // //           p: 2,
// // //           borderBottom: 1,
// // //           borderColor: 'divider',
// // //           display: 'flex',
// // //           alignItems: 'center',
// // //           justifyContent: 'space-between'
// // //         }}>
// // //           <Typography variant="h6">Select Departments</Typography>
// // //           <IconButton onClick={() => setMobileModalOpen(false)}>
// // //             <CloseIcon />
// // //           </IconButton>
// // //         </Box>

// // //         {/* Modal Content */}
// // //         <Box sx={{ p: 2, flex: 1, overflow: 'auto' }}>
// // //        <Autocomplete
// // //   multiple
// // //   options={safeOptions}
// // //   value={selectedDepartments || []}
// // //   onChange={(e, newValue) => setSelectedDepartments(newValue)}
// // //   getOptionLabel={(option) => option || ""}
// // //   isOptionEqualToValue={(option, value) => option === value}
// // //   sx={{ flex: 1, width: "100%" }}
// // //   renderTags={(value, getTagProps) =>
// // //     value.map((option, index) => (
// // //       <Chip
// // //         key={index}
// // //         label={option || ""}
// // //         {...getTagProps({ index })}
// // //         size="small"
// // //       />
// // //     ))
// // //   }
// // //   renderInput={(params) => (
// // //     <TextField
// // //       {...params}
// // //       label="Search and select departments"
// // //       placeholder="Select"
// // //       size="small"
// // //     />
// // //   )}
// // // />
// // //         </Box>

// // //         {/* Modal Footer */}
// // //         <Box sx={{ 
// // //           p: 2, 
// // //           borderTop: 1, 
// // //           borderColor: 'divider',
// // //           display: 'flex',
// // //           gap: 1
// // //         }}>
// // //           <Button
// // //             fullWidth
// // //             variant="outlined"
// // //             onClick={() => {
// // //               setMobileModalOpen(false);
// // //               setSelectedDepartments([]);
// // //             }}
// // //           >
// // //             Clear All
// // //           </Button>
// // //           <Button
// // //             fullWidth
// // //             variant="contained"
// // //             onClick={() => setMobileModalOpen(false)}
// // //             disabled={selectedDepartments.length === 0}
// // //           >
// // //             Done
// // //           </Button>
// // //         </Box>
// // //       </Box>
// // //     </Modal>
// // //   );

// // //   return (
// // //     <>
// // //       <Box sx={{ 
// // //         display: "flex", 
// // //         flexDirection: { xs: "column", sm: "row" },
// // //         alignItems: { xs: "stretch", sm: "center" },
// // //         gap: { xs: 2, sm: 2 },
// // //         mb: 2,
// // //         mt: 2,
// // //         width: "100%"
// // //       }}>
// // //         {!isEdit && (
// // //           <>
// // //             {/* Mobile trigger button */}
// // //             {isMobile ? (
// // //               <Button
// // //                 variant="outlined"
// // //                 onClick={() => setMobileModalOpen(true)}
// // //                 sx={{
// // //                   justifyContent: 'space-between',
// // //                   textTransform: 'none',
// // //                   py: 1.5,
// // //                   fontSize: '0.875rem',
// // //                   color: 'text.primary'
// // //                 }}
// // //               >
// // //                 <span>
// // //                   {selectedDepartments.length > 0 
// // //                     ? `${selectedDepartments.length} department(s) selected`
// // //                     : "Select departments"}
// // //                 </span>
// // //                 <span>▼</span>
// // //               </Button>
// // //             ) : (
// // //               <Autocomplete
// // //                 multiple
// // //                 options={safeOptions}
// // //                 value={selectedDepartments}
// // //                 onChange={(e, newValue) => setSelectedDepartments(newValue)}
// // //                 sx={{ 
// // //                   flex: 1,
// // //                   width: "100%",
// // //                   minWidth: { xs: "100%", sm: "200px" }
// // //                 }}
// // //                 renderTags={(value, getTagProps) =>
// // //                   value.map((option, index) => (
// // //                     <Chip 
// // //                       label={option} 
// // //                       {...getTagProps({ index })}
// // //                       size="small"
// // //                     />
// // //                   ))
// // //                 }
// // //                 renderInput={(params) => (
// // //                   <TextField
// // //                     {...params}
// // //                     label="Search and select departments"
// // //                     placeholder="Select"
// // //                     variant="outlined"
// // //                     className="form-control"
// // //                     size="small"
// // //                   />
// // //                 )}
// // //                 size="small"
// // //               />
// // //             )}
            
// // //             <Button
// // //               className="btn"
// // //               variant="contained"
// // //               onClick={onAddDepartments}
// // //               disabled={selectedDepartments.length === 0}
// // //               sx={{
// // //                 textTransform: "none",
// // //                 fontSize: { xs: "0.875rem", sm: "1rem" },
// // //                 py: { xs: 1, sm: 0.875 },
// // //                 px: { xs: 2, sm: 2 },
// // //                 minWidth: { xs: "100%", sm: "auto" },
// // //                 height: { xs: "44px", sm: "auto" },
// // //                 whiteSpace: "nowrap",
// // //               }}
// // //             >
// // //               {isMobile ? "Add Selected" : "Add Departments"}
// // //             </Button>
// // //           </>
// // //         )}
// // //         {isEdit && (
// // //           <TextField
// // //             disabled
// // //             value={selectedDepartments.join(', ')}
// // //             label="Departments"
// // //             fullWidth
// // //             size={isMobile ? "small" : "medium"}
// // //             multiline
// // //             rows={isMobile ? 2 : 1}
// // //           />
// // //         )}
// // //       </Box>

// // //       {/* Mobile Modal */}
// // //       {isMobile && <MobileDepartmentModal />}
// // //     </>
// // //   );
// // // };

// // // export default DepartmentSelector;



// // import React, { useState } from "react";
// // import {
// //   Box,
// //   Autocomplete,
// //   TextField,
// //   Button,
// //   Chip,
// //   useMediaQuery,
// //   useTheme,
// //   Modal,
// //   IconButton,
// //   Typography,
// //   InputAdornment,
// // } from "@mui/material";
// // import CloseIcon from "@mui/icons-material/Close";
// // import SearchIcon from "@mui/icons-material/Search";
// // import PeopleIcon from "@mui/icons-material/People"; // Employee icon

// // const DepartmentSelector = ({
// //   departments,
// //   selectedDepartments,
// //   onAddDepartments,
// //   setSelectedDepartments,
// //   isEdit,
// //   searchTerm,           // ← New: pass from parent
// //   setSearchTerm,        // ← New: pass from parent
// // }) => {
// //   const theme = useTheme();
// //   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

// //   const [mode, setMode] = useState("department"); // "department" or "employee"
// //   const [mobileModalOpen, setMobileModalOpen] = useState(false);

// //   const safeOptions = (departments || [])
// //     .filter((d) => d && d.name)
// //     .map((d) => d.name);

// //   // Toggle between Department and Employee Search mode
// //   const toggleMode = () => {
// //     setMode((prev) => (prev === "department" ? "employee" : "department"));
// //   };

// //   const MobileDepartmentModal = () => (
// //     <Modal
// //       open={mobileModalOpen}
// //       onClose={() => setMobileModalOpen(false)}
// //       sx={{
// //         display: "flex",
// //         alignItems: "flex-start",
// //         justifyContent: "center",
// //         p: 2,
// //         mt: isMobile ? 10 : 4,
// //       }}
// //     >
// //       <Box
// //         sx={{
// //           bgcolor: "background.paper",
// //           borderRadius: 2,
// //           boxShadow: 24,
// //           width: "100%",
// //           maxWidth: 500,
// //           maxHeight: "80vh",
// //           overflow: "hidden",
// //           display: "flex",
// //           flexDirection: "column",
// //         }}
// //       >
// //         <Box
// //           sx={{
// //             p: 2,
// //             borderBottom: 1,
// //             borderColor: "divider",
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "space-between",
// //           }}
// //         >
// //           <Typography variant="h6">
// //             {mode === "department" ? "Select Departments" : "Search Employees"}
// //           </Typography>
// //           <IconButton onClick={() => setMobileModalOpen(false)}>
// //             <CloseIcon />
// //           </IconButton>
// //         </Box>

// //         <Box sx={{ p: 2, flex: 1, overflow: "auto" }}>
// //           {mode === "department" ? (
// //             <Autocomplete
// //               multiple
// //               options={safeOptions}
// //               value={selectedDepartments || []}
// //               onChange={(e, newValue) => setSelectedDepartments(newValue)}
// //               getOptionLabel={(option) => option || ""}
// //               isOptionEqualToValue={(option, value) => option === value}
// //               sx={{ flex: 1, width: "100%" }}
// //               renderTags={(value, getTagProps) =>
// //                 value.map((option, index) => (
// //                   <Chip
// //                     key={index}
// //                     label={option || ""}
// //                     {...getTagProps({ index })}
// //                     size="small"
// //                   />
// //                 ))
// //               }
// //               renderInput={(params) => (
// //                 <TextField
// //                   {...params}
// //                   label="Search and select departments"
// //                   placeholder="Select"
// //                   size="small"
// //                 />
// //               )}
// //             />
// //           ) : (
// //             <TextField
// //               fullWidth
// //               placeholder="Search employees..."
// //               value={searchTerm}
// //               onChange={(e) => setSearchTerm(e.target.value)}
// //               size="small"
// //               InputProps={{
// //                 startAdornment: (
// //                   <InputAdornment position="start">
// //                     <SearchIcon />
// //                   </InputAdornment>
// //                 ),
// //               }}
// //             />
// //           )}
// //         </Box>

// //         <Box
// //           sx={{
// //             p: 2,
// //             borderTop: 1,
// //             borderColor: "divider",
// //             display: "flex",
// //             gap: 1,
// //           }}
// //         >
// //           <Button
// //             fullWidth
// //             variant="outlined"
// //             onClick={() => {
// //               setMobileModalOpen(false);
// //               setSelectedDepartments([]);
// //             }}
// //           >
// //             Clear All
// //           </Button>
// //           <Button
// //             fullWidth
// //             variant="contained"
// //             onClick={() => setMobileModalOpen(false)}
// //             disabled={mode === "department" && selectedDepartments.length === 0}
// //           >
// //             Done
// //           </Button>
// //         </Box>
// //       </Box>
// //     </Modal>
// //   );

// //   return (
// //     <>
// //       <Box
// //         sx={{
// //           display: "flex",
// //           flexDirection: { xs: "column", sm: "row" },
// //           alignItems: { xs: "stretch", sm: "center" },
// //           gap: { xs: 2, sm: 2 },
// //           mb: 2,
// //           mt: 2,
// //           width: "100%",
// //         }}
// //       >
// //         {!isEdit && (
// //           <>
// //             {/* Desktop + Mobile Logic */}
// //             {isMobile ? (
// //               <Button
// //                 variant="outlined"
// //                 onClick={() => setMobileModalOpen(true)}
// //                 sx={{
// //                   justifyContent: "space-between",
// //                   textTransform: "none",
// //                   py: 1.5,
// //                   fontSize: "0.875rem",
// //                   color: "text.primary",
// //                 }}
// //               >
// //                 <span>
// //                   {mode === "department"
// //                     ? selectedDepartments.length > 0
// //                       ? `${selectedDepartments.length} department(s) selected`
// //                       : "Select departments"
// //                     : "Search employees"}
// //                 </span>
// //                 <span>▼</span>
// //               </Button>
// //             ) : (
// //               // Desktop View with Mode Switching
// //               <Box sx={{ display: "flex", flex: 1, gap: 1, alignItems: "center" }}>
// //                 {mode === "department" ? (
// //                   <Autocomplete
// //                     multiple
// //                     options={safeOptions}
// //                     value={selectedDepartments}
// //                     onChange={(e, newValue) => setSelectedDepartments(newValue)}
// //                     sx={{ flex: 1 }}
// //                     renderTags={(value, getTagProps) =>
// //                       value.map((option, index) => (
// //                         <Chip
// //                           label={option}
// //                           {...getTagProps({ index })}
// //                           size="small"
// //                         />
// //                       ))
// //                     }
// //                     renderInput={(params) => (
// //                       <TextField
// //                         {...params}
// //                         label="Search and select departments"
// //                         placeholder="Select"
// //                         size="small"
// //                       />
// //                     )}
// //                   />
// //                 ) : (
// //                   <TextField
// //                     fullWidth
// //                     placeholder="Search employees..."
// //                     value={searchTerm}
// //                     onChange={(e) => setSearchTerm(e.target.value)}
// //                     size="small"
// //                     InputProps={{
// //                       startAdornment: (
// //                         <InputAdornment position="start">
// //                           <SearchIcon color="action" />
// //                         </InputAdornment>
// //                       ),
// //                     }}
// //                   />
// //                 )}

               
// //               </Box>
// //             )}

// //             {/* Add Departments Button - Only show in Department Mode */}
// //             {mode === "department" && (
// //               <Button
// //                 className="btn"
// //                 variant="contained"
// //                 onClick={onAddDepartments}
// //                 disabled={selectedDepartments.length === 0}
// //                 sx={{
// //                   textTransform: "none",
// //                   fontSize: { xs: "0.875rem", sm: "1rem" },
// //                   py: { xs: 1, sm: 0.875 },
// //                   px: { xs: 2, sm: 2 },
// //                   minWidth: { xs: "100%", sm: "auto" },
// //                   height: { xs: "44px", sm: "auto" },
// //                   whiteSpace: "nowrap",
// //                 }}
// //               >
// //                 {isMobile ? "Add Selected" : "Add Departments"}
// //               </Button>
// //             )}

// //              {/* Toggle Button */}
// //                 <IconButton
// //                   onClick={toggleMode}
// //                   color="primary"
// //                   sx={{ border: "1px solid", borderColor: "divider" }}
// //                   title={
// //                     mode === "department"
// //                       ? "Switch to Employee Search"
// //                       : "Switch to Department Selection"
// //                   }
// //                 >
// //                   {mode === "department" ? <SearchIcon /> : <PeopleIcon />}
// //                 </IconButton>
// //           </>
// //         )}

// //         {isEdit && (
// //           <TextField
// //             disabled
// //             value={selectedDepartments.join(", ")}
// //             label="Departments"
// //             fullWidth
// //             size={isMobile ? "small" : "medium"}
// //             multiline
// //             rows={isMobile ? 2 : 1}
// //           />
// //         )}
// //       </Box>

// //       {/* Mobile Modal */}
// //       {isMobile && <MobileDepartmentModal />}
// //     </>
// //   );
// // };

// // export default DepartmentSelector;


// import React, { useState } from "react";
// import {
//   Box,
//   Autocomplete,
//   TextField,
//   Button,
//   Chip,
//   useMediaQuery,
//   useTheme,
//   Modal,
//   IconButton,
//   Typography,
//   InputAdornment,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import SearchIcon from "@mui/icons-material/Search";
// import PeopleIcon from "@mui/icons-material/People"; // Employee icon

// const DepartmentSelector = ({
//   departments,
//   selectedDepartments,
//   onAddDepartments,
//   setSelectedDepartments,
//   isEdit,
//   searchTerm,           // ← New: pass from parent
//   setSearchTerm,        // ← New: pass from parent
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const [mode, setMode] = useState("department"); // "department" or "employee"
//   const [mobileModalOpen, setMobileModalOpen] = useState(false);

//   const safeOptions = (departments || [])
//     .filter((d) => d && d.name)
//     .map((d) => d.name);

//   // Toggle between Department and Employee Search mode
//   const toggleMode = () => {
//     setMode((prev) => (prev === "department" ? "employee" : "department"));
//   };

//   const MobileDepartmentModal = () => (
//     <Modal
//       open={mobileModalOpen}
//       onClose={() => setMobileModalOpen(false)}
//       sx={{
//         display: "flex",
//         alignItems: "flex-start",
//         justifyContent: "center",
//         p: 2,
//         mt: isMobile ? 10 : 4,
//       }}
//     >
//       <Box
//         sx={{
//           bgcolor: "background.paper",
//           borderRadius: 2,
//           boxShadow: 24,
//           width: "100%",
//           maxWidth: 500,
//           maxHeight: "80vh",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <Box
//           sx={{
//             p: 2,
//             borderBottom: 1,
//             borderColor: "divider",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <Typography variant="h6">
//             {mode === "department" ? "Select Departments" : "Search Employees"}
//           </Typography>
//           <IconButton onClick={() => setMobileModalOpen(false)}>
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         <Box sx={{ p: 2, flex: 1, overflow: "auto" }}>
//           {mode === "department" ? (
//             <Autocomplete
//               multiple
//               options={safeOptions}
//               value={selectedDepartments || []}
//               onChange={(e, newValue) => setSelectedDepartments(newValue)}
//               getOptionLabel={(option) => option || ""}
//               isOptionEqualToValue={(option, value) => option === value}
//               sx={{ flex: 1, width: "100%" }}
//               renderTags={(value, getTagProps) =>
//                 value.map((option, index) => (
//                   <Chip
//                     key={index}
//                     label={option || ""}
//                     {...getTagProps({ index })}
//                     size="small"
//                   />
//                 ))
//               }
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   label="Search and select departments"
//                   placeholder="Select"
//                   size="small"
//                 />
//               )}
//             />
//           ) : (
//             <TextField
//               fullWidth
//               placeholder="Search employees..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               size="small"
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon />
//                   </InputAdornment>
//                 ),
//               }}
//             />
//           )}
//         </Box>

//         <Box
//           sx={{
//             p: 2,
//             borderTop: 1,
//             borderColor: "divider",
//             display: "flex",
//             gap: 1,
//           }}
//         >
//           <Button
//             fullWidth
//             variant="outlined"
//             onClick={() => {
//               setMobileModalOpen(false);
//               setSelectedDepartments([]);
//             }}
//           >
//             Clear All
//           </Button>
//           <Button
//             fullWidth
//             variant="contained"
//             onClick={() => setMobileModalOpen(false)}
//             disabled={mode === "department" && selectedDepartments.length === 0}
//           >
//             Done
//           </Button>
//         </Box>
//       </Box>
//     </Modal>
//   );

//   return (
//     <>
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: { xs: "column", sm: "row" },
//           alignItems: { xs: "stretch", sm: "center" },
//           gap: { xs: 2, sm: 2 },
//           mb: 2,
//           mt: 2,
//           width: "100%",
//         }}
//       >
//         {!isEdit && (
//           <>
//             {/* Desktop + Mobile Logic */}
//             {isMobile ? (
//               <Button
//                 variant="outlined"
//                 onClick={() => setMobileModalOpen(true)}
//                 sx={{
//                   justifyContent: "space-between",
//                   textTransform: "none",
//                   py: 1.5,
//                   fontSize: "0.875rem",
//                   color: "text.primary",
//                 }}
//               >
//                 <span>
//                   {mode === "department"
//                     ? selectedDepartments.length > 0
//                       ? `${selectedDepartments.length} department(s) selected`
//                       : "Select departments"
//                     : "Search employees"}
//                 </span>
//                 <span>▼</span>
//               </Button>
//             ) : (
//               // Desktop View with Mode Switching
//               <Box sx={{ display: "flex", flex: 1, gap: 1, alignItems: "center" }}>
//                 {mode === "department" ? (
//                   <Autocomplete
//                     multiple
//                     options={safeOptions}
//                     value={selectedDepartments}
//                     onChange={(e, newValue) => setSelectedDepartments(newValue)}
//                     sx={{ flex: 1 }}
//                     renderTags={(value, getTagProps) =>
//                       value.map((option, index) => (
//                         <Chip
//                           label={option}
//                           {...getTagProps({ index })}
//                           size="small"
//                         />
//                       ))
//                     }
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label="Search and select departments"
//                         placeholder="Select"
//                         size="small"
//                       />
//                     )}
//                   />
//                 ) : (
//                   <TextField
//                     fullWidth
//                     placeholder="Search employees..."
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     size="small"
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <SearchIcon color="action" />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 )}

               
//               </Box>
//             )}

//             {/* Add Departments Button - Only show in Department Mode */}
//             {mode === "department" && (
//               <Button
//                 className="btn"
//                 variant="contained"
//                 onClick={onAddDepartments}
//                 disabled={selectedDepartments.length === 0}
//                 sx={{
//                   textTransform: "none",
//                   fontSize: { xs: "0.875rem", sm: "1rem" },
//                   py: { xs: 1, sm: 0.875 },
//                   px: { xs: 2, sm: 2 },
//                   minWidth: { xs: "100%", sm: "auto" },
//                   height: { xs: "44px", sm: "auto" },
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 {isMobile ? "Add Selected" : "Add Departments"}
//               </Button>
//             )}

//              {/* Toggle Button */}
//                 <IconButton
//                   onClick={toggleMode}
//                   color="primary"
//                   sx={{ border: "1px solid", borderColor: "divider" }}
//                   title={
//                     mode === "department"
//                       ? "Switch to Employee Search"
//                       : "Switch to Department Selection"
//                   }
//                 >
//                   {mode === "department" ? <SearchIcon /> : <PeopleIcon />}
//                 </IconButton>
//           </>
//         )}

//         {isEdit && (
//           <TextField
//             disabled
//             value={selectedDepartments.join(", ")}
//             label="Departments"
//             fullWidth
//             size={isMobile ? "small" : "medium"}
//             multiline
//             rows={isMobile ? 2 : 1}
//           />
//         )}
//       </Box>

//       {/* Mobile Modal */}
//       {isMobile && <MobileDepartmentModal />}
//     </>
//   );
// };

// export default DepartmentSelector;









import React, { useState } from "react";
import {
  Box,
  Autocomplete,
  TextField,
  Button,
  Chip,
  useMediaQuery,
  useTheme,
  Modal,
  IconButton,
  Typography,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import PeopleIcon from "@mui/icons-material/People";

const DepartmentSelector = ({
  departments,
  selectedDepartments,
  onAddDepartments,
  setSelectedDepartments,
  isEdit,
  searchTerm,
  setSearchTerm,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [mode, setMode] = useState("department");
  const [mobileModalOpen, setMobileModalOpen] = useState(false);

  const safeOptions = (departments || [])
    .filter((d) => d && d.name)
    .map((d) => d.name);

  const toggleMode = () => {
    setMode((prev) => (prev === "department" ? "employee" : "department"));
  };

  const MobileDepartmentModal = () => (
    <Modal
      open={mobileModalOpen}
      onClose={() => setMobileModalOpen(false)}
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        p: 2,
        mt: isMobile ? 10 : 4,
      }}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          width: "100%",
          maxWidth: 500,
          maxHeight: "80vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            p: 2,
            borderBottom: 1,
            borderColor: "divider",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">
            {mode === "department" ? "Select Departments" : "Search Employees"}
          </Typography>
          <IconButton onClick={() => setMobileModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ p: 2, flex: 1, overflow: "auto" }}>
          {mode === "department" ? (
            <Autocomplete
              multiple
              options={safeOptions}
              value={selectedDepartments || []}
              onChange={(e, newValue) => setSelectedDepartments(newValue)}
              getOptionLabel={(option) => option || ""}
              isOptionEqualToValue={(option, value) => option === value}
              sx={{ flex: 1, width: "100%" }}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    key={index}
                    label={option || ""}
                    {...getTagProps({ index })}
                    size="small"
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search and select departments"
                  placeholder="Select"
                  size="small"
                />
              )}
            />
          ) : (
            <TextField
              fullWidth
              placeholder="Search employees..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          )}
        </Box>

        <Box
          sx={{
            p: 2,
            borderTop: 1,
            borderColor: "divider",
            display: "flex",
            gap: 1,
          }}
        >
          <Button
            fullWidth
            variant="outlined"
            onClick={() => {
              setMobileModalOpen(false);
              setSelectedDepartments([]);
            }}
          >
            Clear All
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={() => setMobileModalOpen(false)}
            disabled={mode === "department" && selectedDepartments.length === 0}
          >
            Done
          </Button>
        </Box>
      </Box>
    </Modal>
  );

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 2, sm: 2 },
          mb: 2,
          mt: 2,
          width: "100%",
        }}
      >
        {!isEdit && (
          <>
            {isMobile ? (
              <Button
                variant="outlined"
                onClick={() => setMobileModalOpen(true)}
                sx={{
                  justifyContent: "space-between",
                  textTransform: "none",
                  py: 1.5,
                  fontSize: "0.875rem",
                  color: "text.primary",
                }}
              >
                <span>
                  {mode === "department"
                    ? selectedDepartments.length > 0
                      ? `${selectedDepartments.length} department(s) selected`
                      : "Select departments"
                    : "Search employees"}
                </span>
                <span>▼</span>
              </Button>
            ) : (
              <Box sx={{ display: "flex", flex: 1, gap: 1, alignItems: "center" }}>
                {mode === "department" ? (
                  <Autocomplete
                    multiple
                    options={safeOptions}
                    value={selectedDepartments}
                    onChange={(e, newValue) => setSelectedDepartments(newValue)}
                    sx={{ flex: 1 }}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          label={option}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search and select departments"
                        placeholder="Select"
                        size="small"
                      />
                    )}
                  />
                ) : (
                  <TextField
                    fullWidth
                    placeholder="Search employees..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              </Box>
            )}

            {mode === "department" && (
              <Button
                className="btn"
                variant="contained"
                onClick={onAddDepartments}
                disabled={selectedDepartments.length === 0}
                sx={{
                  textTransform: "none",
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  py: { xs: 1, sm: 0.875 },
                  px: { xs: 2, sm: 2 },
                  minWidth: { xs: "100%", sm: "auto" },
                  height: { xs: "44px", sm: "auto" },
                  whiteSpace: "nowrap",
                }}
              >
                {isMobile ? "Add Selected" : "Add Departments"}
              </Button>
            )}

            <IconButton
              onClick={toggleMode}
              color="primary"
              sx={{ border: "1px solid", borderColor: "divider" }}
              title={
                mode === "department"
                  ? "Switch to Employee Search"
                  : "Switch to Department Selection"
              }
            >
              {mode === "department" ? <SearchIcon /> : <PeopleIcon />}
            </IconButton>
          </>
        )}

        {isEdit && (
          <TextField
            disabled
            value={selectedDepartments.join(", ")}
            label="Departments"
            fullWidth
            size={isMobile ? "small" : "medium"}
            multiline
            rows={isMobile ? 2 : 1}
          />
        )}
      </Box>

      {isMobile && <MobileDepartmentModal />}
    </>
  );
};

export default DepartmentSelector;